import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import LookupSelect from "@/components/images/LookupSelect";
import { useTranslation } from "react-i18next";

export type HandoverProjectMeta = {
  brand: string;
  folderType: string;
  model: string;
  panelStructure: string;
  color: string;
  prelisType: string;
};

export function HandoverProjectMetaStep({
  value,
  onChange,
}: {
  value: HandoverProjectMeta;
  onChange: (next: HandoverProjectMeta) => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="p-4">
      <Card>
        <CardHeader>
          <CardTitle>{t("handover.projectMetaTitle")}</CardTitle>
          <CardDescription>{t("handover.projectMetaDesc")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <LookupSelect
            id="handover-brand"
            type="brand"
            value={value.brand}
            onValueChange={(v) => onChange({ ...value, brand: v || "" })}
            label={t("imagesExtra.brandLabel")}
          />
          <LookupSelect
            id="handover-folderType"
            type="folder_type"
            value={value.folderType}
            onValueChange={(v) => onChange({ ...value, folderType: v || "" })}
            label={t("imagesExtra.typeLabel")}
          />
          <LookupSelect
            id="handover-model"
            type="model"
            value={value.model}
            onValueChange={(v) => onChange({ ...value, model: v || "" })}
            label={t("imagesExtra.modelLabel")}
          />
          <LookupSelect
            id="handover-panelStructure"
            type="panel_structure"
            value={value.panelStructure}
            onValueChange={(v) => onChange({ ...value, panelStructure: v || "" })}
            label={t("imagesExtra.surfaceLabel")}
          />
          <LookupSelect
            id="handover-color"
            type="color"
            value={value.color}
            onValueChange={(v) => onChange({ ...value, color: v || "" })}
            label={t("imagesExtra.colorLabel")}
          />
          <LookupSelect
            id="handover-prelisType"
            type="prelis"
            value={value.prelisType}
            onValueChange={(v) => onChange({ ...value, prelisType: v || "" })}
            label={t("imagesExtra.prelisLabel")}
          />
        </CardContent>
      </Card>
    </div>
  );
}
